/*
 * @Description: 
 * @Author: shenkaiyao
 * @Date: 2020-09-18 11:19:13
 * @LastEditors: 
 * @LastEditTime: 2020-09-18 11:21:08
 */
import SelectCode from './selectCode';

export default SelectCode